// DEPENDENCIES
import axios from 'axios';

// INNER IMPORTS
import { connection } from '../Config/Settings';
import { vimeo_parser } from '../utils';

import { browserHistory } from 'react-router';

import {
    getPinsCall,
    openGeneralMessageModal,
    openLoadingModal,
    closeLoadingModal,
    closePayingMethodsModal,
    openPayingMethodsModal, sendPayingSuccess
} from './main';
import {activateUserFirst, activateUserOnSignup, createActivatedMessage, createWarningMsg} from '../Models/strings';
import { createNotActivatedMessage } from '../Models/strings';
import {BAND, LIVE_MUSIC, MUSICIAN, SERVICE} from "../consts";
import {setErrorBarMessage, setInfoMessageBar, setWarningMessage} from "./messages";
import LocalStorageService from "../Services/LocalStorageService";
import AnalyticsService from "../Services/AnalyticsService";
import localStorageService from "../Services/LocalStorageService";

export const RESET_PASSWORD_REQ             = 'RESET_PASSWORD_REQ';
export const RESET_PASSWORD_SUCCESS         = 'RESET_PASSWORD_SUCCESS';
export const RESET_PASSWORD_FAILED          = 'RESET_PASSWORD_FAILED';

export const CHANGE_PASSWORD_REQ            = 'CHANGE_PASSWORD_REQ';
export const CHANGE_PASSWORD_SUCCESS        = 'CHANGE_PASSWORD_SUCCESS';
export const CHANGE_PASSWORD_FAILED         = 'CHANGE_PASSWORD_FAILED';

export const DELETE_WAITING_LOGIN           = 'DELETE_WAITING_LOGIN';

export const FREE_PROGRAM_CONFIRM           = 'FREE_PROGRAM_CONFIRM';
export const EDIT_BAND_FINDER_PIN           = 'EDIT_BAND_FINDER_PIN';

export const PIN_BOUNCE_REQUEST             = 'PIN_BOUNCE_REQUEST';
export const PIN_BOUNCE_SUCCESS             = 'PIN_BOUNCE_SUCCESS';
export const PIN_BOUNCE_FAILURE             = 'PIN_BOUNCE_FAILURE';

export const GET_USER_LOCATION_REQUEST      = 'GET_USER_LOCATION_REQUEST';
export const GET_USER_LOCATION_SUCCESS      = 'GET_USER_LOCATION_SUCCESS';
export const GET_USER_LOCATION_FAILURE      = 'GET_USER_LOCATION_FAILURE';

export const CLOSE_BOUNCE_MODAL             = 'CLOSE_BOUNCE_MODAL';
export const OPEN_BOUNCE_MODAL              = 'OPEN_BOUNCE_MODAL';

export const OPEN_SUBMIT_BAND_FINDER_MODAL  = 'OPEN_SUBMIT_BAND_FINDER_MODAL';
export const CLOSE_SUBMIT_BAND_FINDER_MODAL = 'CLOSE_SUBMIT_BAND_FINDER_MODAL';

export const OPEN_LOGIN_MODAL               = 'OPEN_LOGIN_MODAL';
export const CLOSE_LOGIN_MODAL              = 'CLOSE_LOGIN_MODAL';

export const OPEN_TEMP_USER_MODAL           = 'OPEN_TEMP_USER_MODAL';
export const CLOSE_TEMP_USER_MODAL          = 'CLOSE_TEMP_USER_MODAL';

export const TEMP_USER_UPDATE_REQUEST       = 'TEMP_USER_UPDATE_REQUEST';
export const TEMP_USER_UPDATE_SUCCESS       = 'TEMP_USER_UPDATE_SUCCESS';
export const TEMP_USER_UPDATE_FAILURE       = 'TEMP_USER_UPDATE_FAILURE';

export const CHECK_USER_VERIFICATION_REQUEST        = 'CHECK_USER_VERIFICATION_REQUEST';
export const CHECK_USER_VERIFICATION_SUCCESS        = 'CHECK_USER_VERIFICATION_SUCCESS';

export const GET_USER_DATA_REQUEST           = 'GET_USER_DATA_REQUEST';
export const GET_USER_DATA_SUCCESS           = 'GET_USER_DATA_SUCCESS';

export const GET_USER_PINS_REQUEST           = 'GET_USER_PINS_REQUEST';
export const GET_USER_PINS_SUCCESS           = 'GET_USER_PINS_SUCCESS';

export const USER_ACTIVATION_REQUEST       = 'USER_ACTIVATION_REQUEST';
export const USER_ACTIVATION_SUCCESS       = 'USER_ACTIVATION_SUCCESS';
export const USER_ACTIVATION_FAILURE       = 'USER_CONFORMATION_FAILURE';

export const USER_CLEAR_USERDATA           = 'USER_CLEAR_USERDATA'

// TODO: this service has been terminated - find a new one and implement
// const LOCATION_BY_IP_API = 'https://freegeoip.net/json/';

export function loginCall(data) {
    return (dispatch) => {
        dispatch(loginRequest());
        // Fetching all pins according to filters specified
        return axios.post(connection().serverUrl + "/api/users/login", data).then((response) => {
            if (!response || !response.data) throw new Error('Failed logging in');
            dispatch(loginSuccess(response.data));
            browserHistory.push('/user-panel');

            LocalStorageService.updateState('users', 'token', response.data.token)
            return Promise.resolve(response.data);
        }).catch((err) => {
            dispatch(loginFailure(err));
            return Promise.reject(err);

        })
    }
}

export function signupCall(data, isPinDataWaiting) {
    return (dispatch, getState) => {
        dispatch(signupRequest());
        // Fetching all pins according to filters specified
        return axios.post(connection().serverUrl + "/api/users/signup", {...data, isPinDataWaiting}).then((response) => {
            if (!response || !response.data) throw new Error('Failed logging in');

            const { data } = response;

            dispatch(signupSuccess(data.token, data.isVerified));
            browserHistory.push('/user-panel');

            LocalStorageService.updateState('users', 'token', data.token)

            // dont show pop up message if user signed up after creating an ad
            const { pinDataWaiting } = getState().users;
            if (pinDataWaiting && pinDataWaiting.name) return;

            const message = activateUserOnSignup();
            dispatch(openGeneralMessageModal(message.header, message.body));
        }).catch((err) => {
            dispatch(signupFailure(err));
            return err;
        })
    }
}

export function updateTempUser({ email, password }) {
    return (dispatch, getState) => {

        dispatch(updateTempUserRequest());

        let config = {
            headers: {
                'Authorization': 'Bearer ' + getState().users.token
            }
        };

        return axios.post(connection().serverUrl + "/api/users/update-temp-user", { email, password }, config)
            .then(res => {
                const localErr = new Error();
                localErr.clientMessage = 'Failed updating user';

                if (!res || !res.data || !res.data.token || !res.data.email) return Promise.reject(localErr);

                dispatch(updateTempUserSuccess({ token: res.data.token, email: res.data.email }));
                LocalStorageService.updateState('users', 'token', res.data.token)

                return Promise.resolve();
            })
            .catch(err => {
                // TODO: handle server error types 'err.response.data'
                dispatch(updateTempUserFailure());
                return Promise.reject(err);
            })
    }
}

export function signOut() {
    return dispatch => {
        browserHistory.replace('/');

        dispatch({type: 'SIGN_OUT'});
        LocalStorageService.updateState('users', 'token', '');
    }
}

export function userPinsCall(token) {
    return (dispatch) => {
        dispatch(userPinsRequest());
        let config = {
            headers: {
                'Authorization': 'Bearer ' + token
            }
        };

        dispatch(openLoadingModal());

        axios.post(connection().serverUrl + "/api/users/userPins", {}, config).then((res) => {
            dispatch(userPinsSuccess(res));

            closeLoadingModal();
        }).catch((err)=> {
            if (err && err.response && err.response.data && err.response.data.statusCode === 'DEACTIVATED_USER') {
                dispatch(setErrorBarMessage('This user was deactivated. Contact support'));
            }

            dispatch(userPinsFailure(err));
            dispatch(closeLoadingModal());
        })
    }
}

// no actions for requests and responses for this action
export function getVimeoThumbnail(vimeoUrl) {
    return dispatch => {
        if (!vimeoUrl || !vimeo_parser(vimeoUrl)) return Promise.resolve();

        return axios.get(`https://vimeo.com/api/oembed.json?url=${vimeoUrl}`)
            .then(res => {
                const tumbnailUrl = res && res.data && res.data.thumbnail_url && res.data.thumbnail_url.replace('\\', '');

                return Promise.resolve(tumbnailUrl);
            })
            .catch(err => Promise.reject(err));

    }
}

export function downgradePin(token, pin) {
    return dispatch => {
        if (!pin) return;

        dispatch(downgradeRequest());

        let config = {
            headers: {
                'Authorization': 'Bearer ' + token
            }
        };

        axios.post(connection().serverUrl + "/api/main/downgrade", { pin }, config)
            .then(res => {
                dispatch(downgradeSuccess(res.data));
                window.location.replace('/user-panel')
                dispatch(userPinsCall(token));
            })
            .catch(err => {
                console.log('Error: Failed downgrading', err);
                dispatch(downgradeFailure(err));
                window.location.replace('/user-panel')
            })
    }
}

export function savePin(token, pin, files) {
    return (dispatch) => {
        if (!pin) return;

        dispatch(savePinRequest());
        let config = {
            headers: {
                'Authorization': 'Bearer ' + token
            }
        };

        const message = createNotActivatedMessage(pin.type);

        if (files && files.length > 0) {
            let formData = new FormData();
            files.forEach((file)=> {
                formData.append('images', file);
            });

            let fileconfig = {
                headers: {
                    'content-type': 'multipart/form-data',
                    'Authorization': 'Bearer ' + token
                },
            };

            axios.post(connection().serverUrl + `/api/upload?d=${pin.id || pin._id || ''}`, formData, fileconfig).then((res)=> {
                if (pin.images && pin.images.length > 0 && res.data && res.data.length > 0) {
                    pin.images = pin.images.concat(res.data);
                } else {
                    pin.images = res.data;
                }

                axios.post(connection().serverUrl + "/api/users/savePin", { pin }, config)
                    .then((res) => {

                        dispatch(savePinSuccess(res));
                        dispatch(userPinsCall(token));

                        if (window.location.href.includes('olimpus')) {
                            const path = window.location.href.split('olimpus');
                            browserHistory.replace('/olimpus' + path[1]);
                        } else {
                            browserHistory.replace('/user-panel');
                        }

                        if (!res.data.isVerified) {
                            dispatch(openGeneralMessageModal(message.header, message.body));
                        }

                        dispatch(deleteWaitingLogin());

                        dispatch(sendPayingSuccess(null));
                    }).catch((err)=> {
                        throw err
                })
            }).catch(err => {
                dispatch(closeLoadingModal())
                if (err && err.response && err.response.data) {
                    if (err.response.data.statusCode === 'DEACTIVATED_USER') dispatch(setErrorBarMessage(('This user was deactivated. Contact support.')))
                    if (err.response.data.statusCode === 'USER_LIMITED') {
                        if (pin.type === LIVE_MUSIC || pin.type === SERVICE) dispatch(openSubmitModal(pin.type));
                        if (pin.type === BAND || pin.type === MUSICIAN) dispatch(openSubmitBandFinder(pin.type));

                        dispatch(openPayingMethodsModal());
                        return dispatch(openGeneralMessageModal('Get a PRO plan', 'You used all of your Basic ads\nGet one of our PRO plans next'));
                    }
                }

                dispatch(savePinFailure(err))
            })
        } else {
            axios.post(connection().serverUrl + "/api/users/savePin", { pin }, config).then((res) => {
                dispatch(savePinSuccess(res));
                dispatch(userPinsCall(token));
                if (window.location.href.includes('olimpus')) {
                    const path = window.location.href.split('olimpus');
                    browserHistory.replace('/olimpus' + path[1]);

                } else {
                    browserHistory.replace('/user-panel');
                }

                if (!res.data.isVerified) {
                    dispatch(openGeneralMessageModal(message.header, message.body));
                }

                dispatch(deleteWaitingLogin());

                dispatch(sendPayingSuccess(null));
            }).catch((err)=> {
                dispatch(closeLoadingModal())
                if (err && err.response && err.response.data) {
                    if (err.response.data.statusCode === 'DEACTIVATED_USER') dispatch(setErrorBarMessage(('This user was deactivated. Contact support.')))
                    if (err.response.data.statusCode === 'USER_LIMITED') {
                        if (pin.type === LIVE_MUSIC || pin.type === SERVICE) dispatch(openSubmitModal(pin.type));
                        if (pin.type === BAND || pin.type === MUSICIAN) dispatch(openSubmitBandFinder(pin.type));

                        dispatch(openPayingMethodsModal());
                        return dispatch(openGeneralMessageModal('Get a PRO plan', 'You used all of your Basic ads\nGet one of our PRO plans next'));
                    }
                }

                dispatch(savePinFailure(err))
            })
        }

    }
}

export function removePin(token, pinId) {
    return (dispatch) => {
        dispatch(removePinRequest());
        dispatch(openLoadingModal());
        let config = {
            headers: {
                'Authorization': 'Bearer ' + token
            }
        };

        axios.post(connection().serverUrl + "/api/users/remove_pin", { pinId }, config).then((res) => {
            dispatch(removePinSuccess(res));
            dispatch(closeLoadingModal());
        }).catch((err)=> {
            dispatch(removePinFailure(err));
            dispatch(closeLoadingModal());
        })
    }
}

export function loginTemp(userId) {
    return (dispatch) => {
        dispatch(loginTempRequest());
        axios.post(connection().serverUrl + "/api/users/loginTemp", { userId }).then((res) => {
            dispatch(loginTempSuccess(res));
            LocalStorageService.updateState('users', 'token', res.data.token)

            browserHistory.push('/user-panel');
        }).catch((err)=> {
            dispatch(loginTempFailure(err))
        })
    }
}

export function openSubmitModalRequest(submitType) {
    return (dispatch, getState) => {
        const userState = getState().users || {};

        // check if user have more then one
        const userPins = userState.myPins || [];
        const nonVerifiedPins = userPins.filter(p => !p.isUserVerified && !p.subscription.temp);

        // dont let user open sign up
        if (nonVerifiedPins.length > 0) {
            const message = activateUserFirst();
            dispatch(openGeneralMessageModal(message.header, message.body));
            dispatch(setWarningMessage('אנא אשר את חשבונך', 'resendEmail'));
            return
        }

        if (submitType === BAND || submitType === MUSICIAN) {
            dispatch(openSubmitBandFinder(submitType));
            return
        }

        dispatch(openSubmitModal(submitType));
    }
}

export function resendEmailConformation() {
    return (dispatch, getState) => {
        const token = getState().users.token;

        if (!token) return;

        let config = {
            headers: {
                'Authorization': 'Bearer ' + token
            }
        };

        axios.post(connection().serverUrl + "/api/users/conformation-email", {}, config).then((res) => {
        }).catch((err)=> {
            console.log(err)
        })
    }
}

export const closeBounceModal = () => {
    return {
        type: CLOSE_BOUNCE_MODAL
    }
};

export const openBounceModal = () => {
    return {
        type: OPEN_BOUNCE_MODAL
    }
};

export function loginRequest() {
    return {
        type: 'LOGIN_REQUEST'
    }
}

export function loginSuccess({ token, isTempUser, isVerified }) {
    return {
        type: 'LOGIN_SUCCESS',
        token,
        isTempUser,
        isVerified
    }
}

export function loginFailure(err) {
    return {
        type: 'LOGIN_FAILURE',
        error: err && err.response && err.response.data
    }
}

export function loginTempRequest() {
    return {
        type: 'LOGIN_TEMP_REQUEST'
    }
}

export function loginTempSuccess(response) {
    return {
        type: 'LOGIN_TEMP_SUCCESS',
        token: response.data.token
    }
}

export function loginTempFailure(err) {
    return {
        type: 'LOGIN_TEMP_FAILURE',
        error: err
    }
}

export function signupRequest() {
    return {
        type: 'SIGNUP_REQUEST'
    }
}

export function signupSuccess(token) {
    return {
        type: 'SIGNUP_SUCCESS',
        token
    }
}

export function signupFailure(err) {
    return {
        type: 'SIGNUP_FAILURE',
        error: err && err.response ? err.response.data : err
    }
}

export function openLoginModal() {
    return {
        type: OPEN_LOGIN_MODAL
    }
}

export function closeLoginModal() {
    return {
        type: CLOSE_LOGIN_MODAL
    }
}

export const openTempUserModal = () => ({
    type: OPEN_TEMP_USER_MODAL
});

export const closeTempUserModal = () =>({
    type: CLOSE_TEMP_USER_MODAL
});

export function openSignupModal(options = {}) {
    return {
        type: 'OPEN_SIGNUP_MODAL',
        signupTextType: options.signupTextType
    }
}

export function closeSignupModal() {
    return {
        type: 'CLOSE_SIGNUP_MODAL'
    }
}

export function openParticipateModal() {
    return {
        type: 'OPEN_PARTICIPATE_MODAL'
    }
}

export function closeParticipateModal() {
    return {
        type: 'CLOSE_PARTICIPATE_MODAL'
    }
}

export function openSubmitModal(submitType) {
    return {
        type: 'OPEN_SUBMIT_MODAL',
        submitType: submitType
    }
}

export function closeSubmitModal() {
    return {
        type: 'CLOSE_SUBMIT_MODAL'
    }
}

export function openSubmitBandFinder(submitType) {
    return {
        type: OPEN_SUBMIT_BAND_FINDER_MODAL,
        submitType: submitType
    }
}

export function closeSubmitBandFinderModal() {
    return {
        type: CLOSE_SUBMIT_BAND_FINDER_MODAL
    }
}

export function chooseSubmitCategory(category) {
    return {
        type: 'CHOOSE_SUBMIT_CATEGORY',
        category: category
    }
}

export function userPinsRequest() {
    return {
        type: 'USER_PINS_REQUEST'
    }
}

export function userPinsSuccess(response) {
    return {
        type: 'USER_PINS_SUCCESS',
        pins: response.data
    }
}

export function userPinsFailure(err) {
    return {
        type: 'USER_PINS_FAILURE',
        error: err
    }
}

export function downgradeRequest() {
    return {
        type: 'DOWNGRADE_PIN_REQUEST'
    }
}

export function downgradeSuccess(pin) {
    return {
        type: 'DOWNGRADE_PIN_SUCCESS',
        pin
    }
}

export function downgradeFailure(err) {
    return {
        type: 'DOWNGRADE_PIN_FAILURE',
        err
    }
}

export function savePinRequest() {
    return {
        type: 'SAVE_PIN_REQUEST'
    }
}

export function savePinSuccess(res) {
    return {
        type: 'SAVE_PIN_SUCCESS',
        response: res
    }
}

export function savePinFailure(err) {
    return {
        type: 'SAVE_PIN_FAILURE',
        error: err
    }
}

export function removePinRequest() {
    return {
        type: 'REMOVE_PIN_REQUEST'
    }
}

export function removePinSuccess() {
    return {
        type: 'REMOVE_PIN_SUCCESS'
    }
}

export function removePinFailure(err) {
    return {
        type: 'REMOVE_PIN_SUCCESS',
        error: err
    }
}

export function editPin(pin) {
    return {
        type: 'EDIT_PIN',
        pin
    }
}

export function editBandFinderPin(pin) {
    return {
        type: EDIT_BAND_FINDER_PIN,
        pin
    }
}

export function submitWaitingLogin(pin, files) {
    return {
        type: 'SUBMIT_WAITING_LOGIN',
        pin,
        files
    }
}

export const checkUserVerificationRequest = () => ({
    type: CHECK_USER_VERIFICATION_REQUEST
})

export const setIsUserVerified = isVerified => ({
    type: CHECK_USER_VERIFICATION_SUCCESS,
    isVerified
})

export const deleteWaitingLogin = () => ({
    type: DELETE_WAITING_LOGIN
});

export const updateTempUserRequest = () => ({
    type: TEMP_USER_UPDATE_REQUEST
});

export const updateTempUserSuccess = ({ token, email }) => ({
    type: TEMP_USER_UPDATE_SUCCESS,
    email,
    token
});

export const updateTempUserFailure = () => ({
    type: TEMP_USER_UPDATE_FAILURE
});

// this is in ES6, this all file should be refactored, for now only new code will be ES6
// also from here line starts code with type variables (not going to refactor the whole project at this point)

export const sendResetPasswordReq = () => ({
    type: RESET_PASSWORD_REQ
});

export const resetPasswordSuccess = (res) => ({
    type: RESET_PASSWORD_SUCCESS,
    response: res
});

export const resetPasswordFailed = (err) => ({
    type: RESET_PASSWORD_FAILED,
    error: err
});

export const changePasswordReq = () => ({
    type: CHANGE_PASSWORD_REQ
});

export const changePasswordSuccess = (res) => ({
    type: CHANGE_PASSWORD_SUCCESS,
    response: res
});

export const changePasswordFailed = (err) => ({
    type: CHANGE_PASSWORD_FAILED,
    error: err
});

export const freeProgramConfirmed = (isActivated, programType) => ({
    type: FREE_PROGRAM_CONFIRM,
    isActivated,
    programType
});

export const bouncePinRequest = () => ({
    type: PIN_BOUNCE_REQUEST
});

export const bouncePinSuccess = (response) => ({
    type: PIN_BOUNCE_SUCCESS,
    response
});

export const bouncePinFailure = (error) => ({
    type: PIN_BOUNCE_FAILURE,
    error,
});

export const getUserLocationRequest = () => ({
    type: GET_USER_LOCATION_REQUEST
});

export const getUserLocationSuccess = (userLocation) => ({
    type: GET_USER_LOCATION_SUCCESS,
    userLocation
});

export const getUserLocationFailure = (error) => ({
    type: GET_USER_LOCATION_FAILURE,
    error,
});

export const getUserDataRequest = () => ({
    type: GET_USER_DATA_REQUEST
})

export const getUserDataSuccess = userData => ({
    type: GET_USER_DATA_SUCCESS,
    userData
})

export const getUserPinsRequest = () => ({
    type: GET_USER_PINS_REQUEST
})

export const getUserPinsSuccess = userPins => ({
    type: GET_USER_PINS_SUCCESS,
    userPins
})

export const resetUserData = () => ({
    type: USER_CLEAR_USERDATA
})

// CALLBACK FUNCTIONS
export const getUserData = () => {
    return (dispatch, getState) => {
        const { token, isVerified } = getState().users;

        if (!token || isVerified) return;
        dispatch(getUserDataRequest());

        let config = {
            headers: {
                'Authorization': 'Bearer ' + token
            }
        };

        return axios.get(connection().serverUrl + '/api/users/data', config)
            .then((res) => {
                const { data } = res;
                if (!data) return;

                dispatch(getUserDataSuccess(data));

                AnalyticsService.init(data)

                if (!data.isVerified) {
                    dispatch(setInfoMessageBar('Please confirm your account', 'resendEmail'));
                }

                return Promise.resolve()
            })
            .catch(err => {
                localStorageService.updateState('users', 'token', '')

                dispatch(resetUserData())
                return Promise.reject(err)
            })
    }
}

export const getUserPins = () => {
    return (dispatch, getState) => {
        const { token, isVerified } = getState().users;

        if (!token || !isVerified) return;
        dispatch(getUserPinsRequest());

        let config = {
            headers: {
                'Authorization': 'Bearer ' + token
            }
        };

        return axios.get(connection().serverUrl + '/api/users/pins', config)
            .then((res) => {
                const { data } = res;
                if (!data) return;

                dispatch(getUserPinsSuccess(data.userPins));

                return Promise.resolve()
            })
            .catch(err => {
                return Promise.reject(err)
            })
    }
}

// TODO: not in use for now - user will return from email to new tab
export const checkUserVerification = () => {
    return (dispatch, getState) => {
        dispatch(checkUserVerificationRequest());

        // check that current user is verified and have token
        const { isVerified, token } = getState().users;

        if (isVerified && token) return;

        return axios.get(connection().serverUrl + '/api/users/check-verified')
            .then((res) => {
                const { data } = res;
                if (!data) return;

                dispatch(setIsUserVerified(data.isVerified));
                return Promise.resolve()
            })
            .catch(err => {
                return Promise.reject()
            })
    };
}

export const sendResetPassword = (email) => {
    return (dispatch) => {
        dispatch(sendResetPasswordReq());
        axios.post(connection().serverUrl + '/api/users/forgot-password', { email }).then((res) => {
            dispatch(resetPasswordSuccess(res));

        }, (err) => {
            dispatch(resetPasswordFailed(err))
        })
    }
};

export const changePassword = (password, token) => {
    return (dispatch) => {
        dispatch(changePasswordReq());
        axios.post(connection().serverUrl + '/api/users/change-password', { token, password }).then((res) => {
            dispatch(changePasswordSuccess(res));
            browserHistory.push('/')
        }, (err) => {
            dispatch(changePasswordFailed(err));
            // TODO: replace this with notification error that user nothing!
            console.error('Error: ', 'no such token');
            browserHistory.push('/')
        })
    }
};

// HELLO, PLEASE NOTE
// You can only bounce an ad once a day, try again tomorrow
export const bouncePin = (token, pin) => {
    return (dispatch) => {
        dispatch(bouncePinRequest());
        let config = {
            headers: {
                'Authorization': 'Bearer ' + token
            }
        };

        axios.post(connection().serverUrl + "/api/pin/bounce", { pinId: pin._id }, config).then((res) => {
            dispatch(bouncePinSuccess(res));
            dispatch(getPinsCall())
        }).catch((err)=> {
            // in case ad was already boosted once this day
            if (err.response.status === 403) {
                dispatch(openGeneralMessageModal('שימו לב', 'אפשר להקפיץ מודעה פעם אחת ביום, נסו שוב מחר'));
                return;
            }

            dispatch(bouncePinFailure(err))
        })
    }
};

export const getUserLocation = () => {
    return dispatch => {
        dispatch(getUserLocationRequest());

        if (navigator.geolocation) {
            return navigator.geolocation.getCurrentPosition(pos => {
                dispatch(getUserLocationSuccess({
                    latitude: pos.coords && pos.coords.latitude,
                    longitude: pos.coords && pos.coords.longitude
                }));
            }, err => {
                // axios.get(LOCATION_BY_IP_API)
                //     .then(res => {
                //         dispatch(getUserLocationSuccess({
                //             latitude: res.data && res.data.latitude,
                //             longitude: res.data && res.data.longitude
                //         }));
                //     })
                //     .catch(err => {
                //         dispatch(getUserLocationFailure(err));
                //     })
            });
        } else {
            // axios.get(LOCATION_BY_IP_API)
            //     .then(res => {
            //         dispatch(getUserLocationSuccess({
            //             latitude: res.data && res.data.latitude,
            //             longitude: res.data && res.data.longitude
            //         }));
            //     })
            //     .catch(err => {
            //         dispatch(getUserLocationFailure(err));
            //     })
        }
    }
};

export const userActivationRequest = () => ({
    type: USER_ACTIVATION_REQUEST
})

export const userActivationSuccess = isVerified => ({
    type: USER_ACTIVATION_SUCCESS,
    isVerified
})

export const userActivationFailure = err => ({
    type: USER_ACTIVATION_FAILURE,
    err
})

export const userActivation = (conformationToken, userId) => {
    return (dispatch, getState) => {
        if (!conformationToken || !userId) return;

        const { token } = getState().users || {};

        // let config = {
        //     headers: {
        //         'Authorization': 'Bearer ' + token
        //     }
        // };

        // check if token and userId same as in token
        // const tokenPayload = getTokenPayload(token) || {};
        // if (tokenPayload._id !== userId) return;

        dispatch(userActivationRequest());

        axios.get(connection().serverUrl + `/api/users/${userId}/activate/${conformationToken}`)
            .then((res) => {
                if (!res || !res.data) throw new Error(`Failed activating user: No data returned`);

                if (token) dispatch(userPinsCall(token));

                dispatch(userActivationSuccess(res.data.isVerified))

                if (res.data.isVerified && !res.data.isFirstTime) return

                const msg = createActivatedMessage();
                dispatch(openGeneralMessageModal(msg.header, msg.body));

            })
            .catch((err)=> {
                // in case ad was already boosted once this day
                dispatch(userActivationFailure(err));

                const errMsg = createWarningMsg('your activation');
                dispatch(openGeneralMessageModal(errMsg.header, errMsg.body));
        })
    }
}




// WEBPACK FOOTER //
// ./src/Actions/users.js